import React from 'react';
import { Link } from 'react-router-dom';

const productList = [
  {
    title: "1D Optical Micrometers",
    description: "High-speed, non-contact dimensional measurement"
  },
  {
    title: "2D Laser Scanners",
    description: "Fast, accurate surface and profile scanning"
  },
  {
    title: "2D Optical Micrometers",
    description: "Precision width, gap, and edge measurements"
  },
  {
    title: "100% Print Inspection",
    description: "Complete inspection of printed materials in real time"
  },
  {
    title: "3D Non-Contact Metrology",
    description: "Optical 3D profilometers & advanced metrology systems"
  },
  {
    title: "Comprehensive Control & Automation Solutions",
    description: "From sensors to multifunctional measuring and control systems"
  },
  {
    title: "Defect Tagging for Converting Machines",
    description: "Automated inspection & defect marking solutions"
  },
  {
    title: "Fully Automated Inspection Systems",
    description: "High-speed, reliable automated quality inspection"
  },
  {
    title: "High-Performance Cast Film Lines",
    description: "Advanced machinery for cast film manufacturing"
  },
  {
    title: "High-Precision Laser-Based Measurement Systems",
    description: "Automated, high-resolution laser systems for defense & industry"
  },
  {
    title: "Laser Triangulation Sensors",
    description: "Precise distance and displacement measurement"
  },
  {
    title: "Magnetic Power Brakes",
    description: "Stable, accurate torque control systems"
  },
  {
    title: "Measurement in Hostile Environments",
    description: "Reliable sensing in extreme temperature, vacuum & radiation"
  },
  {
    title: "Micron-Precision Measurement & Accuracy",
    description: "Ultra-high precision dimensional measurement"
  },
  {
    title: "Multilayer CPP / CPE Cast Film Lines",
    description: "Efficient multilayer film extrusion solutions"
  },
  {
    title: "Online Gauging",
    description: "Real-time thickness and profile monitoring"
  },
  {
    title: "On-Line Measurement & Control Solutions",
    description: "Closed-loop quality control for continuous processes"
  },
  {
    title: "Optoelectronic Devices & Systems",
    description: "Advanced optoelectronic sensing technologies"
  },
  {
    title: "Speed & Length Sensors",
    description: "Accurate speed and length measurement systems"
  },
  {
    title: "Tension Control Systems",
    description: "Precise tension regulation for web handling"
  },
  {
    title: "Web Defect Inspection (AOI)",
    description: "Automated optical inspection for web materials"
  },
  {
    title: "Web Guide Systems",
    description: "Accurate web alignment and tracking solutions"
  }
].sort((a, b) => a.title.localeCompare(b.title));


const Products = () => {

  const features = [
    { id: 1, title: 'Winstar Technology', description: 'Pioneering AOI manufacturing, inspection expertise.', path: '/product1' },
    { id: 2, title: 'Nano Trend Technology', description: 'Innovative measurement systems across industries.', path: '/product3' },
    { id: 3, title: 'SigmaVision and Robotics', description: 'Robotics, Vision Systems, Automation Solutions.', path: '/product4' },
    { id: 4, title: 'Fujian Wellson Machinery', description: 'High-tech cast film machinery specialists.', path: '/product5' },
    { id: 5, title: 'Novation Inc', description: 'Marking and Tracking of Defects With Automation', path: '/product6' },
    { id: 6, title: 'Laser Techniques Co., LLC', description: 'Advanced laser-based inspection & metrology systems.', path: '/product7' },
    { id: 7, title: 'RIFTEK: Sensors and Instruments', description: 'Specialization in precision measurement technologies.', path: '/product8' },
    { id: 8, title: 'Novacam', description: 'Specializes in high-precision and non-contact optical metrology.', path: '/product2' },
  ];

  const firstRow = features.slice(0, 3);
  const secondRow = features.slice(3, 6);
  const thirdRow = features.slice(6, 8);

  const getCardStyle = () =>
    'relative group p-8 rounded-2xl shadow-2xl bg-gradient-to-r from-gray-900 via-gray-800 to-black ' +
    'text-white border border-gray-600 overflow-hidden ' +
    'hover:shadow-[0_0_20px_rgba(255,255,255,0.2)] hover:scale-110 ' +
    'transition-transform duration-500';

  return (
    <>
      <section id="products" className="bg-white text-black py-16 px-8">
        <h2 className="text-4xl font-bold text-center animate-slide-in-up">
          Our Principles
        </h2>

        <p className="text-center max-w-3xl mx-auto mb-12 mt-6 text-lg leading-relaxed">
          We collaborate with world-leading innovators to deliver unmatched precision,
          quality, and performance across industries.
        </p>

        {/* First row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-12">
          {firstRow.map((feature) => (
            <Link to={feature.path} key={feature.id}>
              <div className={getCardStyle()}>

                {/* Normal content */}
                <div className="
                  transition-opacity duration-300
                  opacity-100 group-hover:opacity-0
                ">
                  <h3 className="text-2xl font-semibold">
                    {feature.title}
                  </h3>
                  <p className="mt-4">
                    {feature.description}
                  </p>
                </div>

                {/* Hover content */}
                <div className="
                  absolute inset-0
                  flex items-center justify-center
                  opacity-0 group-hover:opacity-100
                  transition-opacity duration-300
                ">
                  <span className="text-lg font-medium tracking-wide">
                    Click to see more →
                  </span>
                </div>

              </div>
            </Link>
          ))}
        </div>

        {/* Second row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-12">
          {secondRow.map((feature) => (
            <Link to={feature.path} key={feature.id}>
              <div className={getCardStyle()}>

                <div className="transition-opacity duration-300 opacity-100 group-hover:opacity-0">
                  <h3 className="text-2xl font-semibold">
                    {feature.title}
                  </h3>
                  <p className="mt-4">
                    {feature.description}
                  </p>
                </div>

                <div className="
                  absolute inset-0
                  flex items-center justify-center
                  opacity-0 group-hover:opacity-100
                  transition-opacity duration-300
                ">
                  <span className="text-lg font-medium tracking-wide">
                    Click to see more →
                  </span>
                </div>

              </div>
            </Link>
          ))}
        </div>

        {/* Third row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-12 justify-items-center max-w-4xl mx-auto">
          {thirdRow.map((feature) => (
            <Link to={feature.path} key={feature.id} className="w-full max-w-md">
              <div className={getCardStyle()}>

                <div className="transition-opacity duration-300 opacity-100 group-hover:opacity-0">
                  <h3 className="text-2xl font-semibold">
                    {feature.title}
                  </h3>
                  <p className="mt-4">
                    {feature.description}
                  </p>
                </div>

                <div className="
                  absolute inset-0
                  flex items-center justify-center
                  opacity-0 group-hover:opacity-100
                  transition-opacity duration-300
                ">
                  <span className="text-lg font-medium tracking-wide">
                    Click to see more→
                  </span>
                </div>

              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="relative bg-black text-white py-24 px-8 overflow-hidden">

  {/* Ambient background glow */}
  <div className="absolute inset-0 -z-10">
    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
  </div>

  {/* Heading */}
  <div className="text-center mb-16">
    <h2 className="text-5xl font-bold tracking-tight bg-gradient-to-b from-white to-gray-400 bg-clip-text text-transparent">
      Products
    </h2>
    <p className="mt-6 text-gray-400 max-w-3xl mx-auto leading-relaxed">
      Precision-driven solutions across inspection, metrology,
      automation, and advanced control systems
    </p>
  </div>

  {/* Product grid */}
  <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
    {productList.map((item, index) => (
      <div
        key={index}
        className="
          group relative
          rounded-2xl
          border border-white/10
          bg-white/5 backdrop-blur-xl
          p-7
          transition-all duration-500
          hover:-translate-y-2
          hover:border-white/30
          hover:shadow-[0_30px_80px_rgba(255,255,255,0.12)]
        "
      >
        {/* Alphabet badge */}
        <div className="
          absolute -top-4 -right-4
          w-10 h-10
          rounded-full
          flex items-center justify-center
          text-sm font-semibold
          bg-white text-black
          shadow-lg
          transition-transform duration-300
          group-hover:scale-110
        ">
          {item.title.charAt(0)}
        </div>

        {/* Card glow */}
        <div className="
          absolute inset-0 rounded-2xl
          opacity-0 group-hover:opacity-100
          bg-gradient-to-br from-white/10 via-transparent to-transparent
          transition-opacity duration-500
          pointer-events-none
        " />

        <h3 className="text-xl font-semibold tracking-wide">
          {item.title}
        </h3>

        <div className="mt-4 h-px w-10 bg-white/30 group-hover:w-20 transition-all duration-500" />

        <p className="mt-4 text-sm text-gray-300 leading-relaxed">
          {item.description}
        </p>

        {/* Subtle CTA */}
        <div className="
          mt-6 flex items-center gap-2
          text-xs uppercase tracking-widest text-gray-400
          opacity-0 group-hover:opacity-100
          transition-opacity duration-500
        ">
          Reach out to us at rambomble@alphaq.co.in to know more
          <span className="translate-x-0 group-hover:translate-x-1 transition-transform duration-300">
          
          </span>
          <br></br>
        </div>
      </div>
    ))}
  </div>
</section>


    </>
  );
};

export default Products;
